import { render, staticRenderFns } from "./message-time.vue?vue&type=template&id=9b0174fa&"
import script from "./message-time.vue?vue&type=script&lang=js&"
export * from "./message-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b0174fa')) {
      api.createRecord('9b0174fa', component.options)
    } else {
      api.reload('9b0174fa', component.options)
    }
    module.hot.accept("./message-time.vue?vue&type=template&id=9b0174fa&", function () {
      api.rerender('9b0174fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/message-time.vue"
export default component.exports